(function () {
  'use strict';

  if (window.__plzSmoothScrollBooted) return;
  window.__plzSmoothScrollBooted = true;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isWaitlistLink(link) {
    if (!link || link.tagName !== 'A') return false;
    if (link.hasAttribute('data-plz-waitlist')) return true;
    var href = link.getAttribute('href') || '';
    return href.indexOf('waitlist') !== -1;
  }

  function resolveTarget(href) {
    if (!href || href === '#') return null;

    try {
      var url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
        return null;
      }
      if (!url.hash || url.hash === '#') return null;
      return document.getElementById(decodeURIComponent(url.hash.slice(1)));
    } catch (error) {
      if (href.charAt(0) !== '#') return null;
      var id = href.slice(1);
      return id ? document.getElementById(decodeURIComponent(id)) : null;
    }
  }

  function getScrollOffset() {
    var cssValue = getComputedStyle(document.documentElement).getPropertyValue('--plz-header-offset').trim();
    var parsed = parseFloat(cssValue);
    if (!Number.isNaN(parsed) && parsed > 0) return parsed + 8;
    return 80;
  }

  function scrollToTarget(target, smooth) {
    if (!target) return;

    var behavior = smooth && !prefersReducedMotion() ? 'smooth' : 'auto';
    var top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: behavior,
    });
  }

  function updateHash(id) {
    if (!id) return;
    var nextHash = '#' + id;
    if (window.location.hash === nextHash) return;
    history.pushState(null, '', nextHash);
  }

  function handleAnchorClick(event) {
    var link = event.target.closest('a[href]');
    if (!link || isWaitlistLink(link)) return;

    var target = resolveTarget(link.getAttribute('href'));
    if (!target) return;

    event.preventDefault();
    updateHash(target.id);
    scrollToTarget(target, true);
  }

  function handleHashNavigation(smooth) {
    if (!window.location.hash || window.location.hash.indexOf('waitlist') !== -1) return;
    var target = resolveTarget(window.location.hash);
    if (!target) return;
    scrollToTarget(target, smooth);
  }

  document.addEventListener('click', handleAnchorClick);

  window.addEventListener('hashchange', function () {
    handleHashNavigation(true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      handleHashNavigation(false);
    });
  } else {
    handleHashNavigation(false);
  }
})();
